import React from 'react';

import data from 'components/Navigation/data-sample';

import NavigationList from './child-components/NavigationList';

const Navigation = (props) => <NavigationList {...props} items={data.items} />;

export default Navigation;
